import React from 'react';

import { renderChange, renderIdType, renderRosterNote } from '~weekly-planner/lib/common';

import { Column, Row } from '~components/table-view-v3';

const createChangeColumn = (id: string, header: string): Column => ({
  id,
  header,
  type: 'custom',
  component: renderChange,
  componentProps: (row: Row) => ({ ...(row?.[id] ?? {}) }),
});

const changesList: Column[] = [
  {
    id: 'id',
    header: 'Id',
    type: 'custom',
    component: renderIdType,
    componentProps: (row: Row) => ({ id: row?.id, isNew: row?.isNew }),
  },
  createChangeColumn('client', 'Client'),
  createChangeColumn('service', 'Service'),
  createChangeColumn('date', 'Date'),
  createChangeColumn('time', 'Time'),
  createChangeColumn('worker', 'Worker'),
  {
    id: 'notes_admin',
    header: 'Rostering Notes',
    type: 'readonly',
    renderReadOnly: (_value, row) => {
      if (!row?.id) return null;
      return React.createElement(renderRosterNote, { id: row.id as number, notes_admin: row?.notes_admin });
    },
  },
];

export default changesList;
